import React, { useEffect, useRef } from 'react';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import './ServicesPinnedSection.css';

gsap.registerPlugin(ScrollTrigger);

const services = [
  'Lighting Design',
  'Smart Home Integration',
  'Energy Efficient Solutions',
  'Custom Fixtures',
  'Outdoor Lighting',
  'Architectural Consulting',
  'Maintenance & Support',
  'Retrofit Upgrades',
  'Emergency Lighting',
  'Lighting Controls',
];

export default function ServicesPinnedSection() {
  const pinRef = useRef();
  const sectionRef = useRef();
  const listRef = useRef();
  const accentRef = useRef();

  useEffect(() => {
    let st;
    if (window.innerWidth > 900) {
      st = ScrollTrigger.create({
        trigger: sectionRef.current,
        start: 'top 10%',
        end: () => `+=${listRef.current.offsetHeight - window.innerHeight * 0.75 + 100}`,
        pin: pinRef.current,
        pinSpacing: false,
        scrub: false,
        onEnter: () => {
          gsap.to(pinRef.current, { scale: 1.08, opacity: 1, boxShadow: '0 8px 32px 0 rgba(30,40,90,0.18)', duration: 0.35, ease: 'power2.out' });
          gsap.to(accentRef.current, { opacity: 0.18, scale: 1.12, duration: 0.35, ease: 'power2.out' });
        },
        onLeave: () => {
          gsap.to(pinRef.current, { scale: 1, opacity: 0.92, boxShadow: '0 4px 24px 0 rgba(30,40,90,0.07)', duration: 0.35, ease: 'power2.in' });
          gsap.to(accentRef.current, { opacity: 0.08, scale: 1, duration: 0.35, ease: 'power2.in' });
        },
        onEnterBack: () => {
          gsap.to(pinRef.current, { scale: 1.08, opacity: 1, boxShadow: '0 8px 32px 0 rgba(30,40,90,0.18)', duration: 0.35, ease: 'power2.out' });
          gsap.to(accentRef.current, { opacity: 0.18, scale: 1.12, duration: 0.35, ease: 'power2.out' });
        },
        onLeaveBack: () => {
          gsap.to(pinRef.current, { scale: 1, opacity: 0.92, boxShadow: '0 4px 24px 0 rgba(30,40,90,0.07)', duration: 0.35, ease: 'power2.in' });
          gsap.to(accentRef.current, { opacity: 0.08, scale: 1, duration: 0.35, ease: 'power2.in' });
        },
      });
    }
    return () => {
      if (st) st.kill();
    };
  }, []);

  return (
    <section className="services-pinned-section" ref={sectionRef}>
      <div className="services-pin-title-wrapper">
        <div className="services-pin-accent" ref={accentRef} />
        <div className="services-pin-title" ref={pinRef}>
          <h2>Our Services</h2>
        </div>
      </div>
      <div className="services-list" ref={listRef}>
        {services.map((service, i) => (
          <div className="service-card" key={i}>
            <h3>{service}</h3>
            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque vitae velit ex.</p>
          </div>
        ))}
      </div>
    </section>
  );
} 